<template>
<div>
  <div class="title-bar title-h3">
    {{ title }} 도메인 목록
  </div>
  <el-row class="title-bar" type="flex" justify="space-between">
    <div class="vertical-center-box">
      <el-button class="mr-r4" size="mini" type="primary" :disabled="!isRoot" @click="addDomain">추가</el-button>
      <el-button size="mini" :disabled="!checkChangeFlag" @click="deleteDomain">삭제</el-button>
    </div>
    <div class="vertical-center-box">
      <w-header-search-button size="mini" @click="showSearchTool = !showSearchTool" />
    </div>
  </el-row>
  <el-row class="mr-b20">
    <el-table-wrapper v-loading="isLoading" ref="domainTable" :show-search-tool="showSearchTool" :total="total" row-class-name="c-dblclick" pagination :show-custom-header="true"
    :data="dataList" :columns="dataColumns" :column-default="columnDefault" @condition-change="loadDomainList" @selection-change="domainSelectionChange" @cell-dblclick="onDbclickRow" />
  </el-row>
  <w-domain-setting-popup ref="domainSettingPopup" :popup-type="domainPopupType" @reloadData="reloadAllData" />
</div>
</template>

<script>
import { isNil, isEmpty } from 'lodash';
import { columnDefault } from '@/constants/table';
import { APM_OBJTYPE } from '@/constants/objdefine';
import { EMPTY_TEXT } from '@/utils/string';
import { convertThousandSeparatorFormat } from '@/utils/number';
import ApmSettingAPI from '@/api/settings/apm/apm-setting';
import msgUtil from '@/utils/message';
import WDomainSettingPopup from '../popup/DomainSettingPopup';

export default {
  name: 'WDomainSettingView',
  components: {
    WDomainSettingPopup,
  },
  props: {
    currentNode: {
      type: Object,
    },
    selectedType: String,
  },
  data() {
    return {
      columnDefault,
      selectedDomains: [],
      checkChangeFlag: false,
      showSearchTool: false,
      dataList: null,
      isLoading: false,
      total: 0,
      dataColumns: [
        {
          type: 'selection',
        },
        {
          prop: 'domainName',
          label: '도메인명',
          searchable: true,
          sortable: true,
        },
        // {
        //   prop: 'txStoreDay',
        //   label: '트랜잭션 보관 주기',
        //   searchable: true,
        //   sortable: true,
        //   formatter: this.convertDayFormat,
        // },
      ],
      domainPopupType: null,
    };
  },
  computed: {
    isRoot() {
      return this.currentNode.type === 'root';
    },
    title() {
      return APM_OBJTYPE[this.selectedType];
    },
  },
  watch: {
    currentNode: {
      immediate: true,
      handler(currentNode) {
        if (isEmpty(currentNode) || currentNode.type !== 'root') {
          return;
        }
        this.$nextTick(() => {
          this.loadDomainList();
        });
      },
    },
  },
  methods: {
    /**
     * 1000의 자리 숫자 , 표현
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     * @author jda
     */
    convertDayFormat(row, column, value) {
      if (isNil(value)) {
        return EMPTY_TEXT;
      }
      return `${convertThousandSeparatorFormat(value)} 일`;
    },
    /**
     * Root 선택시 도메인 리스트 조회
     * @return {[type]} [description]
     * @author jda
     */
    loadDomainList() {
      if (this.currentNode.type !== 'root') {
        return;
      }

      this.isLoading = true;
      const tableParams = this.$refs.domainTable.getParameter();
      ApmSettingAPI.getDomainList({ ...tableParams }).then((response) => {
        this.isLoading = false;
        if (response.data.success) {
          this.dataList = response.data.data;
          this.total = response.data.total;
        } else {
          this.dataList = [];
          this.total = 0;
        }
      });
    },
    /**
     * 선택된 도메인
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     * @author jda
     */
    domainSelectionChange(row) {
      this.selectedDomains = row;
      if (this.isRoot && row.length > 0) {
        this.checkChangeFlag = true;
      } else {
        this.checkChangeFlag = false;
      }
    },
    /**
     * 선택된 도메인들을 삭제한다.
     * @return {[type]} [description]
     * @author jda
     */
    deleteDomain() {
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)).then(() => {
        ApmSettingAPI.deleteDomain(this.selectedDomains).then((response) => {
          if (response.data.success) {
            this.reloadAllData();
          }
          this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '도메인', response.data.success));
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '도메인', false));
        });
      }).catch(() => {});
    },
    /**
     * 도메인 정보 편집 팝업창을 띄운다.
     * @param  {[type]} record [description]
     * @return {[type]}        [description]
     * @author jda
     */
    onDbclickRow(record) {
      this.domainPopupType = 'MODIFY';
      this.$refs.domainSettingPopup.open(record);
    },
    /**
     * 도메인 추가 팝업창을 띄운다.
     * @author jda
     */
    addDomain() {
      this.domainPopupType = 'ADD';
      this.$refs.domainSettingPopup.open();
    },
    /**
     * 좌측 트리와 도메인 리스트를 재조회한다.
     * @return {[type]} [description]
     * @author jda
     */
    reloadAllData() {
      this.loadDomainList();
      this.$emit('reloadTree');
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/apm/ConfigSettings/components/view/DomainSettingView.vue